import { MESSAGE_TYPES, SENDER_TYPES } from './constants.js';

/**
 * Uma resposta do agente vira N mensagens, e elas precisam contar como UM bloco: é o bloco que
 * ganha o botão de depuração, porque o rastro é do TURNO, não da mensagem.
 *
 * A regra geral exige o MESMO MINUTO DE RELÓGIO (`Math.floor(createdAt / 60)` igual), o que não
 * é o mesmo que "dentro de 60s": 10:00:59 e 10:01:01 não agrupam. Para mensagem humana isso é
 * invisível — quem digita raramente cruza a virada no meio da frase. Para agente é rotina: um
 * turno medido em produção gerou quatro mensagens ao longo de sete segundos, e um turno assim
 * cai nos dois lados da virada e vira dois blocos, com dois botões para uma resposta só.
 *
 * Por isso a janela para bot é em SEGUNDOS. O agrupamento de mensagem humana fica exatamente
 * como estava.
 */
export const JANELA_BOT_SEGUNDOS = 60;

export const ehMensagemDeBot = message =>
  message.messageType === MESSAGE_TYPES.OUTGOING &&
  (message.sender?.type === SENDER_TYPES.AGENT_BOT ||
    message.senderType === SENDER_TYPES.AGENT_BOT ||
    (!message.sender && !message.additionalAttributes?.senderName));

const remetenteDe = message => message.senderId ?? message.sender?.id;

/**
 * Diz se a mensagem em `index` deve ser agrupada com a seguinte.
 *
 * @param {Number} index - posição da mensagem atual
 * @param {Array} searchList - lista de mensagens (camelCase)
 * @returns {Boolean}
 */
export const shouldGroupWithNext = (index, searchList) => {
  if (index === searchList.length - 1) return false;

  const current = searchList[index];
  const next = searchList[index + 1];

  if (next.status === 'failed') return false;

  if (ehMensagemDeBot(current) && ehMensagemDeBot(next)) {
    return (
      remetenteDe(next) === remetenteDe(current) &&
      next.createdAt - current.createdAt <= JANELA_BOT_SEGUNDOS
    );
  }

  const hasSameSender = remetenteDe(next) === remetenteDe(current);

  const areBothTemplates =
    next.messageType === MESSAGE_TYPES.TEMPLATE &&
    current.messageType === MESSAGE_TYPES.TEMPLATE;

  if (!hasSameSender || areBothTemplates) return false;

  if (current.messageType !== next.messageType) return false;

  // Check if messages are in the same minute by rounding down to nearest minute
  return Math.floor(next.createdAt / 60) === Math.floor(current.createdAt / 60);
};
